/* unplugin-vue-components disabled */import { render } from "./xComponentModal.vue?vue&type=template&id=67c87d1f"
import script from "./xComponentModal.vue?vue&type=script&lang=js"
export * from "./xComponentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__